/* unplugin-vue-components disabled */import { render } from "./welfare_details.vue?vue&type=template&id=52454362"
import script from "./welfare_details.vue?vue&type=script&lang=js"
export * from "./welfare_details.vue?vue&type=script&lang=js"

import "./welfare_details.vue?vue&type=style&index=0&id=52454362&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__